// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const itemStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        width: ${pxToRem(32)} !important; /* Override breakpoint widths */
        height: ${pxToRem(32)};
        margin: 0;
        border-radius: ${pxToRem(2)};
        font-size: ${x => x.theme.design.typography.size.base};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        color: ${getColor("text")};
        transition: ${transitionHoverStyles("color", "background-color")};
    `;
};

const pagination: Styleguide["pagination"] = {
    defaultProps: {
        hidePerPageSelect: true,
        hideSinglePage: true,
        navIconsSrc: {
            previousPage: ChevronLeft,
            nextPage: ChevronRight,
        },
        cssOverrides: {
            currentButton: css`
                min-height: ${pxToRem(32)} !important;
                color: ${getContrastColor("secondary")}; /* Store Custom Code */
                background-color: ${getColor("secondary")}; /* Store Custom Code */
            `,
            pagination: css`
                margin-top: 1em;
                justify-content: center;

                &:not(#important) /* Override breakpoint values */ {
                    ${({ theme }) => css`
                        margin: ${theme.design.typography.spacing.base} 0;

                        ${breakpoint("md")} {
                            margin: ${theme.design.typography.spacing.large} 0;
                        }
                    `}

                    &:first-child {
                        margin-top: 0;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                @media print {
                    display: none;
                }
            `,
            perPageSelect: css`
                ${breakpointValues(["none"], "display")}
            `,
            ellipsis: css`
                ${itemStyles()}
                font-size: ${pxToRem(22)};
                line-height: ${pxToRem(20)};
                cursor: default;
            `,
            linkList: css`
                ul {
                    display: flex;
                    align-items: center;
                    /* Bunzl Custom Code */
                    column-gap: ${pxToRem(4)};
                }
            `,
        },
        buttonProps: {
            color: "secondary",
            typographyProps: {
                size: "inherit",
                weight: "inherit",
            },
            // width at important to override next & previous button
            css: css`
                padding: ${pxToRem(0, 6)}; /* Store Custom Code */
                width: ${pxToRem(32)} !important; /* Store Custom Code */
                height: ${pxToRem(32)};
                margin: 0 ${pxToRem(4)};
                color: ${getColor("text.main")};
                border: none;
                border-radius: 50%; /* Store Custom Code */
                font-size: ${({ theme }) => theme.design.typography.size.base};
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};

                ${IconWrapper} {
                    color: ${getColor("primary")};

                    > * {
                        stroke-width: 3;
                    }
                }
                &:not(:disabled) {
                    &:hover,
                    &:active {
                        background-color: ${getColor("secondary")};
                        color: white;

                        ${IconWrapper} {
                            color: inherit;
                        }
                    }
                }
                &:disabled {
                    background-color: ${getColor("common.accentLighter")};
                    border-color: ${getColor("common.accentLighter")};

                    ${IconWrapper} {
                        color: ${getColor("common.disabled")};
                    }
                }
            `,
        },
        selectProps: {
            sizeVariant: "xsmall" as any,
            cssOverrides: null as any,
            labelProps: null as any,
        },
    },
};

export default pagination;
